const API_URL = process.env.REACT_APP_API_URL;

// export const getFileUrl = (image) => {
// 	return `${API_URL.replace(/\/$/, '')}/${image.replace(/^\//, '')}`;
// };

export const getFileUrl = (image) => {
	return `${API_URL}${image}`;
};
